<template>
  <div class="ai-assistant-widget" v-if="canUseAi">
    <div class="ai-assistant-widget__panel" v-if="isOpen">
      <header>
        <div>
          <h1>Pergunte ao Fluxoo</h1>
          <span v-if="aiUsage">{{ aiUsage.remaining }} de {{ aiUsage.limit }} perguntas restantes hoje</span>
        </div>
        <button type="button" class="ai-assistant-widget__close" @click="isOpen = false">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M9.29404 7.89904L15.5 1.68604C15.6857 1.50039 15.79 1.24859 15.79 0.986043C15.79 0.723492 15.6857 0.471695 15.5 0.286043C15.3144 0.100392 15.0626 -0.00390625 14.8 -0.00390625C14.5375 -0.00390625 14.2857 0.100392 14.1 0.286043L7.90004 6.49904L1.68604 0.289043C1.50039 0.103392 1.24859 -0.00090625 0.986043 -0.00090625C0.723492 -0.00090625 0.471695 0.103392 0.286043 0.289043C0.100392 0.474695 -0.00390625 0.726492 -0.00390625 0.989043C-0.00390625 1.25159 0.100392 1.50339 0.286043 1.68904L6.50004 7.89904L0.289043 14.107C0.103392 14.2927 -0.00090625 14.5445 -0.00090625 14.807C-0.00090625 15.0696 0.103392 15.3214 0.289043 15.507C0.474695 15.6927 0.726492 15.797 0.989043 15.797C1.25159 15.797 1.50339 15.6927 1.68904 15.507L7.90004 9.29304L14.108 15.499C14.2937 15.6847 14.5455 15.789 14.808 15.789C15.0706 15.789 15.3224 15.6847 15.508 15.499C15.6937 15.3134 15.798 15.0616 15.798 14.799C15.798 14.5365 15.6937 14.2847 15.508 14.099L9.29404 7.89904Z" fill="#6F6F6F"/>
          </svg>
        </button>
      </header>
      <div class="ai-assistant-widget__messages" ref="messagesEl">
        <p class="ai-assistant-widget__empty" v-if="!messages.length">
          Pergunte algo sobre os documentos do seu órgão. Ex: "quais ofícios sobre reforma escolar estão pendentes?"
        </p>
        <div v-for="(message, index) in messages" :key="index" class="ai-assistant-widget__message" :class="message.role">
          <p>{{ message.text }}</p>
          <div class="ai-assistant-widget__sources" v-if="message.sources?.length">
            <RouterLink
              v-for="source in message.sources"
              :key="source.id"
              :to="{ name: 'admin.documents.show', params: { id: source.id } }"
              @click="isOpen = false"
            >
              #{{ source.number }} — {{ source.title }}
            </RouterLink>
          </div>
        </div>
        <div class="ai-assistant-widget__message assistant" v-if="isAsking">
          <SpinnerLoaderButton :isButton="false" :height="22" />
        </div>
      </div>
      <form class="ai-assistant-widget__input" @submit.prevent="ask">
        <input type="text" v-model="question" placeholder="Digite sua pergunta..." :disabled="isAsking">
        <button type="submit" :disabled="!question.trim() || isAsking || (!!aiUsage && aiUsage.remaining <= 0)">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M4 20L21 12L4 4L4 10L15 12L4 14L4 20Z" fill="currentColor"/>
          </svg>
        </button>
      </form>
    </div>
    <button type="button" class="ai-assistant-widget__toggle" @click="isOpen = !isOpen">
      <svg v-if="!isOpen" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none">
        <path d="M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z" fill="currentColor"/>
        <path d="M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z" fill="currentColor"/>
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
        <path d="M9.29404 7.89904L15.5 1.68604C15.6857 1.50039 15.79 1.24859 15.79 0.986043C15.79 0.723492 15.6857 0.471695 15.5 0.286043C15.3144 0.100392 15.0626 -0.00390625 14.8 -0.00390625C14.5375 -0.00390625 14.2857 0.100392 14.1 0.286043L7.90004 6.49904L1.68604 0.289043C1.50039 0.103392 1.24859 -0.00090625 0.986043 -0.00090625C0.723492 -0.00090625 0.471695 0.103392 0.286043 0.289043C0.100392 0.474695 -0.00390625 0.726492 -0.00390625 0.989043C-0.00390625 1.25159 0.100392 1.50339 0.286043 1.68904L6.50004 7.89904L0.289043 14.107C0.103392 14.2927 -0.00090625 14.5445 -0.00090625 14.807C-0.00090625 15.0696 0.103392 15.3214 0.289043 15.507C0.474695 15.6927 0.726492 15.797 0.989043 15.797C1.25159 15.797 1.50339 15.6927 1.68904 15.507L7.90004 9.29304L14.108 15.499C14.2937 15.6847 14.5455 15.789 14.808 15.789C15.0706 15.789 15.3224 15.6847 15.508 15.499C15.6937 15.3134 15.798 15.0616 15.798 14.799C15.798 14.5365 15.6937 14.2847 15.508 14.099L9.29404 7.89904Z" fill="#FFF"/>
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, onMounted, ref } from 'vue'
import { useAxios } from '@/api/axios'
import { user, hasAiModule } from '@/global/states/GlobalState'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'

interface AiSource {
  id: number
  number: number
  title: string
}

interface AiMessage {
  role: 'user' | 'assistant'
  text: string
  sources?: AiSource[]
}

const axios = useAxios()
const isOpen = ref(false)
const question = ref('')
const isAsking = ref(false)
const messages = ref<AiMessage[]>([])
const aiUsage = ref<{ limit: number, used: number, remaining: number }>()
const messagesEl = ref<HTMLElement>()

const canUseAi = computed(() => hasAiModule.value && (user.value.can?.('create_documents') ?? false))

function getAiUsage (): void {
  axios.get('/api/documents/ai-generate-content/usage')
    .then((res) => {
      aiUsage.value = res.data
    })
}

function scrollToBottom (): void {
  nextTick(() => {
    if (messagesEl.value) {
      messagesEl.value.scrollTop = messagesEl.value.scrollHeight
    }
  })
}

function ask (): void {
  const currentQuestion = question.value.trim()
  if (!currentQuestion || isAsking.value) return

  messages.value.push({ role: 'user', text: currentQuestion })
  question.value = ''
  isAsking.value = true
  scrollToBottom()

  const body = new FormData()
  body.append('question', currentQuestion)

  axios.post('/api/ai/ask', body)
    .then((res) => {
      messages.value.push({ role: 'assistant', text: res.data.answer, sources: res.data.sources })
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        messages.value.push({ role: 'assistant', text: 'Não foi possível obter uma resposta agora. Tente novamente.' })
      }
    })
    .finally(() => {
      isAsking.value = false
      getAiUsage()
      scrollToBottom()
    })
}

onMounted(() => {
  if (canUseAi.value) {
    getAiUsage()
  }
})
</script>

<style scoped lang="scss">
  .ai-assistant-widget{
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 50;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    row-gap: 12px;

    &__toggle{
      width: 56px;
      height: 56px;
      min-width: 56px;
      border-radius: 50%;
      border: none;
      background: $fluxoo-primary-color;
      color: #FFF;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.2);
      transition: background .2s;
      &:hover{
        background: $fluxoo-primary-color-hover;
      }
    }

    &__panel{
      width: 340px;
      max-width: calc(100vw - 48px);
      height: 460px;
      max-height: calc(100vh - 140px);
      display: flex;
      flex-direction: column;
      background: #FFF;
      border-radius: 20px;
      box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.18);
      overflow: hidden;

      header{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 16px 18px;
        border-bottom: 1px solid #F1F1F1;
        h1{
          color: #090909;
          font-family: 'Nunito', sans-serif;
          font-size: 16px;
          font-weight: 800;
          margin: 0 0 2px 0;
        }
        span{
          color: #6F6F6F;
          font-family: 'Inter', sans-serif;
          font-size: 12px;
        }
        button{
          border: none;
          background: transparent;
          cursor: pointer;
          padding: 2px;
        }
      }
    }

    &__close{
      display: flex;
    }

    &__messages{
      flex: 1;
      overflow-y: auto;
      padding: 16px 18px;
      display: flex;
      flex-direction: column;
      row-gap: 12px;
    }

    &__empty{
      color: #6F6F6F;
      font-family: 'Inter', sans-serif;
      font-size: 13px;
      line-height: 1.5;
      text-align: start;
      margin: 0;
    }

    &__message{
      max-width: 85%;
      border-radius: 14px;
      padding: 10px 14px;
      box-sizing: border-box;
      p{
        margin: 0;
        font-family: 'Inter', sans-serif;
        font-size: 13px;
        line-height: 1.45;
        text-align: start;
        white-space: pre-wrap;
      }
      &.user{
        align-self: flex-end;
        background: $fluxoo-primary-color;
        p{ color: #FFF; }
      }
      &.assistant{
        align-self: flex-start;
        background: #F1F1F1;
        p{ color: #090909; }
        display: flex;
        flex-direction: column;
        row-gap: 8px;
      }
    }

    &__sources{
      display: flex;
      flex-direction: column;
      row-gap: 4px;
      a{
        color: $fluxoo-primary-color;
        font-family: 'Inter', sans-serif;
        font-size: 12px;
        font-weight: 600;
        text-decoration: underline;
      }
    }

    &__input{
      display: flex;
      align-items: center;
      column-gap: 8px;
      padding: 12px 14px;
      border-top: 1px solid #F1F1F1;
      input{
        flex: 1;
        height: 40px;
        border-radius: 20px;
        border: 1px solid #D3D3D3;
        padding: 0 16px;
        box-sizing: border-box;
        font-family: 'Inter', sans-serif;
        font-size: 13px;
        color: #090909;
        &:focus{
          outline: none;
          border-color: $fluxoo-primary-color;
        }
        &::placeholder{
          color: #949494;
        }
      }
      button{
        width: 40px;
        height: 40px;
        min-width: 40px;
        border-radius: 50%;
        border: none;
        background: $fluxoo-primary-color;
        color: #FFF;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background .2s;
        &:disabled{
          background: #D3D3D3;
          cursor: not-allowed;
        }
        &:hover:not(:disabled){
          background: $fluxoo-primary-color-hover;
        }
      }
    }
  }

  @media(max-width: 425px){
    .ai-assistant-widget{
      right: 16px;
      bottom: 16px;
      &__panel{
        height: 60dvh;
      }
    }
  }
</style>
